import * as marietta from '../../..';
import { SVGSprite } from '../../flash/display';

export default class RoofLine {
    _firstDot: marietta.core.Point;

    get firstDot() { return this._firstDot; }

    set firstDot(_dot) {
      this._firstDot = _dot;
      this.updateTransforms();
    }

    _secondDot: marietta.core.Point;

    get secondDot() { return this._secondDot; }

    set secondDot(_dot) {
      this._secondDot = _dot;
      this.updateTransforms();
    }

    roofObj: marietta.webcad.item.Roof;

    index: number;

    public spt: SVGSprite;

    /**
     * コンストラクタ
     * */
    constructor(targetNode:Element, id: number) {
      this.index = id;

      // ラインの作成
      const viewObj: SVGGElement = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      viewObj.setAttribute('stroke', '#3598DC');
      viewObj.setAttribute('stroke-width', '10');
      viewObj.setAttribute('opacity', '0');
      viewObj.setAttribute('d', marietta.webcad.util.SVGUtil.getPathLineString(new marietta.core.Point(0, 0), new marietta.core.Point(10, 10)));
      viewObj.setAttribute('id', `roof_line_${id}`);
      this.spt = new SVGSprite(viewObj);

      targetNode.appendChild(viewObj);

      // アクション
      let ua = marietta.webcad.WebCADGlobal.userAgentManager;
      if (ua.isMobile || ua.isTablet) {
        this.viewObj.addEventListener('touchstart', this.onMouseDownMe, { passive: false });
      } else {
        this.viewObj.addEventListener('mouseout', this.hideHighlight);
        this.viewObj.addEventListener('mouseover', this.showHighlight);
        this.viewObj.addEventListener('mousedown', this.onMouseDownMe);
      }
      ua = null;
    }

    /**
     * Translateのアップデート
     */
    updateTransforms() {
      if (!this.firstDot || !this.secondDot) return;
      this.viewObj.setAttribute('d', marietta.webcad.util.SVGUtil.getPathLineString(new marietta.core.Point(this.firstDot.x, this.firstDot.y), new marietta.core.Point(this.secondDot.x, this.secondDot.y)));
    }

    /**
     * HTMLElementの取得
     */
    public get viewObj(): HTMLElement {
      return this.spt.element;
    }

    /**
     * ハイライト
     * */
    highlight(value: boolean) {
      if (value) {
        this.viewObj.setAttribute('opacity', '100');
      } else {
        this.viewObj.setAttribute('opacity', '0');
      }
    }

    /**
     * ハイライト非表示
     */
    hideHighlight = () => {
      if (this.roofObj.itemInfo.roof_type !== 1) return;
      // 次の描画中であれば、行わない
      if (marietta.webcad.WebCADGlobal.itemManager.isDrawMode) return;

      console.log('highlight');
      const self = this;
      self.highlight(false);
    }

    /**
     * ハイライト表示
     */
    showHighlight = () => {
      if (this.roofObj.itemInfo.roof_type !== 1) return;
      // 次の描画中であれば、行わない
      if (marietta.webcad.WebCADGlobal.itemManager.isDrawMode) return;

      const self = this;
      self.highlight(true);
    }

    /**
     * 軒・妻の設定
     */
    onMouseDownMe = () => {
      if (this.roofObj.itemInfo.roof_type !== 1) return;
      // 次の描画中であれば、行わない
      if (marietta.webcad.WebCADGlobal.itemManager.isDrawMode) return;

      const self = this;
      // 軒・妻設定ダイアログ
      const target = marietta.webcad.WebCADGlobal.showDialog(marietta.webcad.view.dialog.RoofSideSetting) as marietta.webcad.view.dialog.RoofSideSetting;
      target.type = self.roofObj.itemInfo.dotList[self.index - 1].type;
      target.index = self.index;
    }

    /**
     * 表示ON
     */
    show() {
      this.spt.element.style.visibility = 'visible';
    }

    /**
     * 表示ON
    */
    hide() {
      this.spt.element.style.visibility = 'hidden';
    }
}
